import { jsx as w } from "react/jsx-runtime";
import { c as d } from "../../../clsx-OuTLNxxd.js";
import { FlexChildren as x } from "./flexChildren/flexChildren.js";
const m = "_flex_1y1zn_29", j = "_wrap_1y1zn_67", b = "_nowrap_1y1zn_70", v = "_shrink_1y1zn_88", _ = {
  flex: m,
  "flex-row": "_flex-row_1y1zn_34",
  "flex-column": "_flex-column_1y1zn_37",
  "justify-start": "_justify-start_1y1zn_40",
  "justify-end": "_justify-end_1y1zn_43",
  "justify-center": "_justify-center_1y1zn_46",
  "justify-space-between": "_justify-space-between_1y1zn_49",
  "justify-space-around": "_justify-space-around_1y1zn_52",
  "align-start": "_align-start_1y1zn_55",
  "align-end": "_align-end_1y1zn_58",
  "align-center": "_align-center_1y1zn_61",
  "align-stretch": "_align-stretch_1y1zn_64",
  wrap: j,
  nowrap: b,
  "wrap-reverse": "_wrap-reverse_1y1zn_73",
  "is-full-width": "_is-full-width_1y1zn_79",
  "is-full-height": "_is-full-height_1y1zn_82",
  "flex-grow": "_flex-grow_1y1zn_85",
  shrink: v,
  "hide-on-mobile": "_hide-on-mobile_1y1zn_91",
  "is-scrollable": "_is-scrollable_1y1zn_99",
  "gap-0": "_gap-0_1y1zn_105",
  "gap-1": "_gap-1_1y1zn_108",
  "gap-2": "_gap-2_1y1zn_111",
  "gap-3": "_gap-3_1y1zn_114",
  "gap-4": "_gap-4_1y1zn_117",
  "gap-5": "_gap-5_1y1zn_120",
  "gap-6": "_gap-6_1y1zn_123",
  "gap-7": "_gap-7_1y1zn_126",
  "gap-8": "_gap-8_1y1zn_129",
  "gap-9": "_gap-9_1y1zn_132",
  "gap-10": "_gap-10_1y1zn_135",
  "gap-11": "_gap-11_1y1zn_138",
  "gap-12": "_gap-12_1y1zn_141",
  "gap-14": "_gap-14_1y1zn_144",
  "gap-16": "_gap-16_1y1zn_147",
  "gap-18": "_gap-18_1y1zn_150",
  "gap-20": "_gap-20_1y1zn_153",
  "gap-24": "_gap-24_1y1zn_156",
  "gap-28": "_gap-28_1y1zn_159",
  "gap-32": "_gap-32_1y1zn_162",
  "gap-36": "_gap-36_1y1zn_165",
  "gap-40": "_gap-40_1y1zn_168",
  "gap-44": "_gap-44_1y1zn_171",
  "gap-48": "_gap-48_1y1zn_174",
  "gap-52": "_gap-52_1y1zn_177",
  "gap-56": "_gap-56_1y1zn_180",
  "gap-60": "_gap-60_1y1zn_183",
  "gap-64": "_gap-64_1y1zn_186",
  "gap-72": "_gap-72_1y1zn_189",
  "gap-80": "_gap-80_1y1zn_192",
  "gap-96": "_gap-96_1y1zn_195",
  "no-margin": "_no-margin_1y1zn_198",
  "dialog-overlay-show": "_dialog-overlay-show_1y1zn_1",
  "dialog-content-show": "_dialog-content-show_1y1zn_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1y1zn_1"
};
function k({
  children: n,
  direction: g = "row",
  justifyContent: p = "start",
  alignItems: e = "start",
  flexWrap: l = "wrap",
  className: s = "",
  isFullWidth: y = !1,
  isFullHeight: i = !1,
  gap: a,
  style: t,
  noMargin: r = !1,
  flexGrow: z = !1,
  hideOnMobile: o = !1,
  shrink: f = !1,
  isScrollable: c = !1,
  ...u
}) {
  const h = d(
    _.flex,
    _[`flex-${g}`],
    _[`justify-${p}`],
    _[`align-${e}`],
    _[l],
    y && _["is-full-width"],
    i && _["is-full-height"],
    a && _[`gap-${a}`],
    r && _["no-margin"],
    z && _["flex-grow"],
    o && _["hide-on-mobile"],
    f && _.shrink,
    c && _["is-scrollable"],
    s
  );
  return /* @__PURE__ */ w("div", { className: h, ...u, style: t, children: n });
}
k.FlexChildren = x;
export {
  k as Flex
};
